import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from 'styled-components';

import GlobalStyle from './styles/GlobalStyle';
import { lightTheme } from './styles/themes';
import PortalInactive from './pages/PortalInactive';

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        {/* Global Site Tag (gtag.js) - Google Analytics */}
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_TAG}`}
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.REACT_APP_GA_TAG}', {
              page_path: window.location.pathname,
            });
          `,
          }}
        />
      </Helmet>
      <ThemeProvider theme={lightTheme}>
        <GlobalStyle />
        <PortalInactive />
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
